import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const CallHistory = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    {
      key: "1",
      name: "Antony",
      phone: "1234567890",
      callType: "Incoming",
      duration: "00:25",
      date: "14 Jan 2024",
    },
    {
      key: "2",
      name: "Antony",
      phone: "1234567890",
      callType: "Outgoing",
      duration: "00:25",
      date: "14 Jan 2024",
    },
    {
      key: "3",
      name: "Antony",
      phone: "1234567890",
      callType: "Incoming",
      duration: "00:26",
      date: "14 Jan 2024",
    },
    {
      key: "4",
      name: "Antony",
      phone: "1234567890",
      callType: "Missed Call",
      duration: "00:25",
      date: "14 Jan 2024",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "",
      render: () => <input type="checkbox" />,
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Call Type",
      dataIndex: "callType",
    },
    {
      title: "Duration",
      dataIndex: "duration",
    },
    {
      title: "Date & Time",
      dataIndex: "date",
    },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Call History List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default CallHistory;